import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { formatDate } from "@eres/core/dist/DateTime";
import { HTRequest } from "../../../api/entities";

interface Props {
	request: HTRequest;
}

class ReqDetails extends Component<Props> {
	render() {
		const { request } = this.props;
		let propertyNo = "-", area = "-";
		if ( request && request.Properties && request.Properties.length > 0 ) {
			const property = request.Properties[ 0 ];
			propertyNo = property.PropertyNumber;
			area = getLocalValue( { en: property.AreaNameEn, ar: property.AreaNameAr } );
		}
		return <>
			<div className="section-title">
				<h5>{ Strings.request_details }</h5>
			</div>
			<div className="flex-grid">
				<div>
					<span>{ Strings.request_date }</span>
					<span dir={ "ltr" }>{ formatDate( request.RequestedOn.asDate(), "DD/MM/YYYY hh:mm A", "en" ) } </span>
				</div>
				<div>
					<span>{ Strings.request_status }</span>
					<span>{ getLocalValue( {
						en: request.RequestStatusNameEn,
						ar: request.RequestStatusNameAr
					} ) }</span>
				</div>
				<div>
					<span>{ Strings.property_number }</span>
					<span>{ propertyNo }</span>
				</div>
				<div>
					<span>{ Strings.area }</span>
					<span>{ area }</span>
				</div>
			</div>
		</>;
	}
}

export default ReqDetails;
